<template>
    <p class="joy-font-primary-400 joy-color-neutral-60 joy-mt-6 joy-mb-6">
        {{ t('projectclient.expenses.page.footer.contact') }}
        <VJoyLink target="_blank" :href="`/messages/${conversationId}`" :text="freelancer" class="joy-font-weight-normal" />
    </p>
    <span class="joy-font-primary-300 joy-color-neutral-40">
        {{ t('projectclient.expenses.page.footer.compliance') }}
    </span>
</template>

<script setup lang="ts">
    import {useTranslation} from '#imports';
    import {VJoyLink} from '@maltjoy/core-vue';

    const {t} = useTranslation();

    defineProps<{freelancer: string; conversationId: string}>();
</script>

<style lang="scss" scoped>
    // DS overrides for link styles
    a {
        font-weight: var(--joy-font-weight-normal) !important;
        text-decoration: underline !important;
    }
</style>
